// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"5228da70","374":"e6d82b3c","378":"63d0d032","413":"588d150b","432":"fdb11fae","466":"ee89dbe4","488":"3ed9cd1e","507":"54bce2d0","696":"be82b2f9"}[chunkId] + ".chunk.js";
};